import {
  FormGroup,
  HTMLSelect,
} from "@blueprintjs/core";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import { observer } from "mobx-react";
import * as React from "react";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";

interface Props {
}

interface State {
}

@observer
export default class EmpresaSegmentos
  extends React.Component<Props, State> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <MDBRow>
          <div style={{ width: 500, marginLeft: 30 }}>
            <FormGroup label={"Autopeças"}>
              <HTMLSelect onChange={e => EmpresaStore.obs.empresa_edit.seg_auto_pecas = e.target.value === "1"} value={EmpresaStore.obs.empresa_edit.seg_auto_pecas ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label={"Veterinário/pet"}>
              <HTMLSelect onChange={e => EmpresaStore.obs.empresa_edit.seg_vet_pet = e.target.value === "1"} value={EmpresaStore.obs.empresa_edit.seg_vet_pet ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label={"Refrigerantes"}>
              <HTMLSelect onChange={e => EmpresaStore.obs.empresa_edit.seg_refrigerantes = e.target.value === "1"} value={EmpresaStore.obs.empresa_edit.seg_refrigerantes ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label={"Águas e outras bebidas"}>
              <HTMLSelect onChange={e => EmpresaStore.obs.empresa_edit.seg_agua_out = e.target.value === "1"} value={EmpresaStore.obs.empresa_edit.seg_agua_out ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label={"Lâmpadas, reatores e starter"}>
              <HTMLSelect onChange={e => EmpresaStore.obs.empresa_edit.seg_lamp_reatores = e.target.value === "1"} value={EmpresaStore.obs.empresa_edit.seg_lamp_reatores ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label={"Materiais de limpeza"}>
              <HTMLSelect onChange={e => EmpresaStore.obs.empresa_edit.seg_mat_limpeza = e.target.value === "1"} value={EmpresaStore.obs.empresa_edit.seg_mat_limpeza ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label={"Pneumáticos, câmaras de ar e protetores de borracha"}>
              <HTMLSelect onChange={e => EmpresaStore.obs.empresa_edit.seg_pneumaticos_prot = e.target.value === "1"} value={EmpresaStore.obs.empresa_edit.seg_pneumaticos_prot ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label={"Produtos alimentícios"}>
              <HTMLSelect onChange={e => EmpresaStore.obs.empresa_edit.seg_alimenticios = e.target.value === "1"} value={EmpresaStore.obs.empresa_edit.seg_alimenticios ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label={"Produtos de perfumaria e de higiene pessoal e cosméticos"}>
              <HTMLSelect onChange={e => EmpresaStore.obs.empresa_edit.seg_perf_cosm = e.target.value === "1"} value={EmpresaStore.obs.empresa_edit.seg_perf_cosm ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

          </div>

          <div style={{ width: 500, marginLeft: 30 }}>

            <FormGroup label={"Produtos eletrônicos, eletroeletrônicos e eletrodomésticos"}>
              <HTMLSelect onChange={e => EmpresaStore.obs.empresa_edit.seg_eletro = e.target.value === "1"} value={EmpresaStore.obs.empresa_edit.seg_eletro ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label={"Rações para animais domésticos"}>
              <HTMLSelect onChange={e => EmpresaStore.obs.empresa_edit.seg_racoes = e.target.value === "1"} value={EmpresaStore.obs.empresa_edit.seg_racoes ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label={"Sorvetes e preparados para fabricação de sorvetes em máquinas"}>
              <HTMLSelect onChange={e => EmpresaStore.obs.empresa_edit.seg_sorvetes_fab = e.target.value === "1"} value={EmpresaStore.obs.empresa_edit.seg_sorvetes_fab ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label={"Tintas e vernizes"}>
              <HTMLSelect onChange={e => EmpresaStore.obs.empresa_edit.seg_tintas = e.target.value === "1"} value={EmpresaStore.obs.empresa_edit.seg_tintas ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label={"Material de construção"}>
              <HTMLSelect onChange={e => EmpresaStore.obs.empresa_edit.seg_mat_construcao = e.target.value === "1"} value={EmpresaStore.obs.empresa_edit.seg_mat_construcao ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label={"Veículos automotores novos"}>
              <HTMLSelect onChange={e => EmpresaStore.obs.empresa_edit.seg_veiculos_automotores = e.target.value === "1"} value={EmpresaStore.obs.empresa_edit.seg_veiculos_automotores ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label={"Veículos novos de duas e três rodas motorizados"}>
              <HTMLSelect onChange={e => EmpresaStore.obs.empresa_edit.seg_veiculos_novos = e.target.value === "1"} value={EmpresaStore.obs.empresa_edit.seg_veiculos_novos ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

            <FormGroup label={"Medicamentos de uso humano e outros produtos farmacêuticos"}>
              <HTMLSelect onChange={e => EmpresaStore.obs.empresa_edit.seg_medicamentos_humano = e.target.value === "1"} value={EmpresaStore.obs.empresa_edit.seg_medicamentos_humano ? "1" : "0"}>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </HTMLSelect>
            </FormGroup>

          </div>
        </MDBRow>
      </>
    );
  }
}
